import { createAction, props } from '@ngrx/store';
import { CommonIdFindUniversitiesRequest } from 'src/app/models/common-id/common-id-find-universities-request';
import { CommonIdFindUniversitiesResponse } from 'src/app/models/common-id/common-id-find-universities-response';
import { AppError } from '../../errors/app-error';

/* 該当ユーザーに登録されている志望校の大学情報取得処理 */
export const commonIdFindUniversities = createAction(
  '[CommonIdFindUniversities] Common Id Find Universities',
  props<{ request: CommonIdFindUniversitiesRequest }>()
);
export const commonIdFindUniversitiesSuccess = createAction(
  '[CommonIdFindUniversities] Common Id Find Universities Success',
  props<{ response: CommonIdFindUniversitiesResponse[] }>()
);
export const commonIdFindUniversitiesFailure = createAction(
  '[CommonIdFindUniversities] Common Id Find Universities Failure',
  props<{ error: AppError }>()
);
export const initializeCommonIdFindUniversitiesResult = createAction('[CommonIdAuth] Initialize Find Universities Result');
